import { siteNames } from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types';

export const isJobsDBSite = (location: string): boolean =>
  location === siteNames.employer.seek.th ||
  location === siteNames.employer.seek.hk;

export const isJobStreetSite = (location: string): boolean =>
  location === siteNames.employer.seek.my ||
  location === siteNames.employer.seek.sg ||
  location === siteNames.employer.seek.id ||
  location === siteNames.employer.seek.ph ||
  location === siteNames.employer.seek.my;

type ANZSite =
  | typeof siteNames.employer.seek.au
  | typeof siteNames.employer.seek.nz;

export const isANZSite = (site: EmployerSiteName): site is ANZSite =>
  site === siteNames.employer.seek.au || site === siteNames.employer.seek.nz;
